<template>
  <div class="h-full videoUpload">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="bg-dark p-6 h-full">
      <div
        class="relative bg-white h-full w-full flex flex-col item-center rounded justify-center"
      >
        <ChunkUploadPhp
          v-if="isLoaded && showUploadButton && ('uploadvideophp' == this.$route.name)"
          :key="chunkUploadComponentKey"
          :storage-folder="selectedStorageFolder"
          :storage-id="selectedStorageId"
          :encoder-id="selectedEncoderId"
          :is-paid="$store.getters.isPaidUser"
          :max-size="maxSize"
          :video-details="this.vid"
          :headers="chunkuploadHeaders"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
        />
        <ChunkUploadPackage
          v-if="isLoaded && showUploadButton && ('uploadvideopackage' == this.$route.name)"
          :key="chunkUploadComponentKey"
          :storage-folder="selectedStorageFolder"
          :storage-id="selectedStorageId"
          :encoder-id="selectedEncoderId"
          :is-paid="$store.getters.isPaidUser"
          :max-size="maxSize"
          :video-details="this.vid"
          :headers="chunkuploadHeaders"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
        />
        <ChunkUploadS3
          v-if="isLoaded && showUploadButton  && ('uploadvideos3' == this.$route.name)"
          :key="chunkUploadComponentKey"
          :storage-folder="selectedStorageFolder"
          :storage-id="selectedStorageId"
          :encoder-id="selectedEncoderId"
          :is-paid="$store.getters.isPaidUser"
          :max-size="maxSize"
          :video-details="this.vid"
          :headers="chunkuploadHeaders"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
        />
      </div>
    </div>
    <portal to="headerContent">
      <div class="flex">
        <gd-button class="mr-4 exitBtn" @click="exitUpload">
          {{ $t('frontend_exit') }}
        </gd-button>
      </div>
    </portal>
  </div>
</template>

<script>
import Video from '@/models/Video';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import themeConfig from '@/theme/themeConfig.js';
import ChunkUploadPhp from '../../components/upload/ChunkUploadPhp.vue';
import ChunkUploadPackage from '../../components/upload/ChunkUploadPackage.vue';
import ChunkUploadS3 from '../../components/upload/ChunkUploadS3.vue';
import Auth from '@groovepages/gd-lib/auth';
import store from '@/state';
import axios from 'axios';
import router from '@/router';
import Storage from '@/models/Storage';
import Encoder from '@/models/Encoder';

import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue,
  a,
} from 'vuelidate/lib/validators';

export default {
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',
  metaInfo() {
    return { title: 'Video Configuration' };
  },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      maxSize: 5000,
      loaderColor: themeConfig.appPrimaryColor,
      model: {
        folder_name: '',
      },
      chunkUploadComponentKey: 0,
      chunkuploadHeaders: {
        Authorization: 'Bearer ' + Auth.authenticatedUser().token,
        'Cache-Control': null,
        'X-Requested-With': null,
      },
      isLoaded: 0,
      selectedStorageId: 0,
      selectedEncoderId: 0,
      selectedStorageFolder: 0,
      videoOptions: {
        showControls: 1,
        controls: true,
        controlBar: {
          playToggle: true,
          captionsButton: false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: true,
          progressControl: {
            seekBar: true,
          },
          fullscreenToggle: false,
          playbackRateMenuButton: false,
          pictureInPictureToggle: true,
          volumePanel: true,
          muteToggle: true,
        },
        autoplay: true,
        muted: false,
        poster: '',
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
        loop: false,
      },
    };
  },
  validations: {
    model: {},
  },
  computed: {
    ChunkUpload() {
      console.log('route',this.$route.name);
      if('uploadvideophp' == this.$route.name){
        return () => import(`../../components/upload/ChunkUploadPhp.vue`);
      } else if('uploadvideopackage' == this.$route.name){
        return () => import(`../../components/upload/ChunkUploadPackage.vue`);
      } else if('uploadvideos3' == this.$route.name){
        return () => import(`../../components/upload/ChunkUploadS3.vue`);
      } else {
        return false;
      }
    },
    showUploadButton() {
      if (!this.$store.getters.isPaidUser) {
        if (
          this.selectedStorageId > 0 &&
          this.selectedEncoderId > 0 &&
          this.selectedStorageFolder &&
          this.selectedStorageFolder != 0 &&
          this.selectedStorageFolder != '0' &&
          this.selectedStorageFolder != ''
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  async created() {
    this.showLoader();
    let videoId = this.$route.params.id;
    this.$wait.start('videos');
    this.vid = await Video.$find(videoId);
    this.enable_control = this.vid.settings.control;
    this.enable_mute = this.vid.settings.muted;
    this.enable_autoplay = this.vid.settings.autoplay;
    this.videoDimensionsType = this.vid.video_dimensions.type;
    this.videoWidth = this.vid.video_dimensions.width;
    this.videoHeight = this.vid.video_dimensions.height;

    this.videoOptions.showControls = this.vid.settings.control;
    this.videoOptions.autoplay = this.vid.settings.autoplay;
    this.videoOptions.muted = this.vid.settings.muted;
    this.videoOptions.sources[0].src = this.vid.video_source;
    this.videoOptions.poster = this.vid.settings.splashImg;
    this.logoImage = this.vid.settings.logoImg;

    this.videoDimensionsType = this.vid.video_dimensions.type;
    this.videoWidth = this.vid.video_dimensions.width;
    this.videoHeight = this.vid.video_dimensions.height;
    this.enable_overly = this.vid.settings.overlay.enable;
    this.overlay_text = this.vid.settings.overlay.txt;
    this.videoOptions.loop = this.vid.end_actions.start_loop_from_begining;
    this.VideoName = this.vid.name;
    this.VideoDesc = this.vid.description;
    this.selectedStorageId = this.vid.storage_id;
    this.selectedStorageFolder = this.vid.folder;
    this.selectedEncoderId = this.vid.encoder_id;
    this.status = true;

    if (this.vid.call_to_actions.length) {
      this.cat_opt = true;
      let obj = this.vid.call_to_actions;
      console.log(obj);
      this.ctaOptInForm = obj;
      //this.cta_start_time = obj.cta.time;
    } else {
    }

    if (this.vid.video_source == '') {
      this.is_video_src = false;
    } else {
      this.is_video_src = true;
    }

    if (!this.$store.getters.isPaidUser) {
      this.storageAccounts = await Storage.$get();
      this.encodingAccounts = await Encoder.$get();
    }

    this.model.groovevideo_name = this.vid.name;
    this.model.groovevideo_desc = this.vid.description;
    //this.fetchVideos();

    let remainingSizeData = await axios.get('remaining');
    this.remaining = remainingSizeData.data.data.res;

    if (this.remaining < 5000000000) {
      this.maxSize = Math.floor(this.remaining / 1000000);
    }

    this.isLoaded = 1;

    this.hideLoader();
  },
  components: {
    Loading,
    ChunkUploadPackage,
    ChunkUploadPhp,
    ChunkUploadS3,
  },
  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
    exitUpload() {
      router.push({ name: 'videos' });
    },
    cancelUpload() {
      let videoId = this.$route.params.id;
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: videoId },
      });
    },
    savevideo() {
      console.log('hello');
    },
  },
};
</script>

<style lang="scss">
.uploadArea {
  background-color: #191d3a;
}

.exitBtn {
  color: #191d3a !important;
  border-color: #d5d8e5 !important;
}

.dropzone-custom-title {
  font-size: 20px !important;
  color: #191d3a;
}

.uploadTab {
  border-bottom: 1px solid #d5d8e5;
  margin-top: 10px;
  width: 100%;
  .gs-default-tabs-item {
    color: #989ab2;
    &.tabs__item_active {
      color: #fd6481;
    }
  }
  button.tabs__item {
    display: inline-block;
    padding-bottom: 5px;
    &:focus,
    &:active {
      outline: none;
    }
  }
}
</style>
